import "./src/styles/theme.css"
import "swiper/swiper.scss"

import wrapRootElement from "./src/wrapRootElement"
import wrapPageElement from "./src/wrapPageElement"

const TRANSITION_DELAY = 600

const shouldUpdateScroll = ({
  routerProps: { location },
  prevRouterProps: { location: prevLocation },
  getSavedScrollPosition,
}) => {
  if (location.action === "PUSH") {
    if (
      location.pathname !== prevLocation.pathname &&
      location.pathname !== "/"
    ) {
      window.setTimeout(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
      }, TRANSITION_DELAY)
    }
  } else {
    window.setTimeout(() => {
      const savedPosition = getSavedScrollPosition(location)
      if (savedPosition) {
        window.scrollTo({
          top: savedPosition[1],
          left: savedPosition[0],
          behavior: "smooth",
        })
      } else {
        window.scrollTo(...[0, 0])
      }
    }, TRANSITION_DELAY)
  }
  return false
}

export { wrapRootElement, wrapPageElement, shouldUpdateScroll }
